module.exports = __webpack_public_path__ + "img/monez-guzmang-early-bird.e3efaa1.jpg";